import {DeviceSetting, dynamicOperators, DynamicOperators, DynamicSetting, LogicalOperators, logicalOperators, ServerDeviceSetting, TimeSetting, ValueSetting} from '../../../Types/types';

export const columns = [
	{
		id: 'name',
		title: 'Name',
		width: 250,
		priority: 1,
		isKey: true,
	},
	{
		id: 'allDevices',
		title: 'Devices',
		width: 200,
		priority: 3,
	},
];

export function serverDeviceSettingToBrowser(deviceSetting: ServerDeviceSetting): DeviceSetting {
	const operationsCopy = [...deviceSetting.deviceSettingOperations];
	let allDevices = deviceSetting.devices
		.map((device) => {
			return device.friendlyName ? device.friendlyName : device.imei;
		})
		.join(', ');

	if (allDevices.length > 50) {
		allDevices = allDevices.substring(0, 50) + '...';
	}
	return {
		id: deviceSetting.id,
		name: deviceSetting.name,
		devices: deviceSetting.devices.map((device) => {
			return device.friendlyName ? device.friendlyName : device.imei;
		}),
		transmissionSettings: operationsCopy
			.filter((operation) => {
				if (operation.settingType === 'transmit') {
					return true;
				}
			})
			.map((operation) => {
				return {
					type: operation.type as 'time' | 'value' | 'dynamic',
					value: createSettingValue(operation.value, operation.operation),
					connection: operation.connection as 'and' | 'or' | 'finished',
				};
			}),
		collectionSettings: operationsCopy
			.filter((operation) => {
				if (operation.settingType === 'collect') {
					return true;
				}
			})
			.map((operation) => {
				return {
					type: operation.type as 'time' | 'value' | 'dynamic',
					value: createSettingValue(operation.value, operation.operation),
					connection: operation.connection as 'and' | 'or' | 'finished',
				};
			}),
		allDevices: allDevices,
	};
}

function createSettingValue(value: number | string, operator: string | undefined): TimeSetting | ValueSetting | DynamicSetting {
	if (operator) {
		if (dynamicOperators.includes(operator as DynamicOperators)) {
			return {value: value as string, operator: operator as DynamicOperators} as DynamicSetting;
		}

		if (logicalOperators.includes(operator as LogicalOperators)) {
			return {value: value as string, operator: operator as LogicalOperators} as ValueSetting;
		}

		return value as TimeSetting;
	} else {
		if (typeof value === 'number') {
			return value as TimeSetting;
		} else {
			return value as unknown as TimeSetting;
		}
	}
}
